export default __webpack_public_path__ + "static/media/chj2.090a72e1.jpg";